import ApiService from './apiService';
import { CreditReportTransaction } from '../models/credit/credit-report-transaction';
import { CreditReportRequest } from '../models/credit/credit-report-request';
import { CreditReportResponse } from '../models/credit/credit-report-response';

class CreditService extends ApiService {
  private static instance?: CreditService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!CreditService.instance) {
      CreditService.instance = new CreditService();
    }
    return CreditService.instance;
  }

  searchTransactions(startDate?: Date, endDate?: Date): Promise<CreditReportTransaction[]> {
    const params = {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
    };
    return this.client.get(`credit/transactions`, params).then((response) => response.data);
  }

  getCreditReportForVendor(vendor: string, request: CreditReportRequest): Promise<CreditReportResponse> {
    return this.client.post(`credit/vendor/${vendor}`, request).then((response) => response.data);
  }
}

export default CreditService;
